import { useLocation, useNavigate } from "react-router-dom";
import Scrollspy from "react-scrollspy";
import homeNavData from "./data";
import internshipFloatingNavData from "./Internshipfloatingnavdata";
import Nav from "./Nav";
import "./floating-nav.css";

const FloatingNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isInternshipPage = location.pathname.startsWith("/virtual-internship/");

  const data = isInternshipPage ? internshipFloatingNavData : homeNavData;
  const homeItem = isInternshipPage ? data.find((item) => item.link === "/") : null;
  const spyData = isInternshipPage ? data.filter((item) => item.link !== "/") : data;

  const sectionIds = spyData
    .map((item) => {
      const link = item.link;
      if (link.startsWith("#")) {
        return link.substring(1);
      } else if (link.startsWith("/#")) {
        return link.substring(2);
      }
      return link;
    })
    .filter(
      (id) =>
        typeof id === "string" &&
        id !== "/" &&
        !id.startsWith("/virtual-internship"),
    );

  const handleNavClick = (e, link) => {
    e.preventDefault();

    if (link === "/") {
      navigate("/");
    } else if (link.startsWith("/#")) {
      const anchor = link.substring(2);

      if (location.pathname === "/") {
        const element = document.getElementById(anchor);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      } else {
        navigate("/");
        setTimeout(() => {
          const element = document.getElementById(anchor);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 100);
      }
    } else if (link.startsWith("#")) {
      // Handle internal page anchors (for internship pages)
      const anchor = link.substring(1);
      const element = document.getElementById(anchor);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else {
      navigate(link);
    }
  };

  return (
    <ul id="floating__nav">
      {homeItem && <Nav item={homeItem} onClick={handleNavClick} />}
      <Scrollspy
        offset={-350}
        className="scrollspy"
        items={sectionIds}
        currentClassName="active"
      >
        {spyData.map((item) => (
          <Nav key={item.id} item={item} onClick={handleNavClick} />
        ))}
      </Scrollspy>
    </ul>
  );
};

export default FloatingNav;
